import { FunctionComponent } from 'react'

import CurrencyLabel from 'components/util/currencyLabel'
import { TransferIndicators } from '../transferIndicators'
import attendancesIcon from 'assets/icons/kpi/atendimentos.svg'
import pmrIcon from 'assets/icons/kpi/pmr.svg'
import ticketIcon from 'assets/icons/kpi/ticket.svg'
import transfersCss from '../styles.module.scss'

const TransferMetrics: FunctionComponent<{ indicators: TransferIndicators }> = ({
  indicators,
}) => {
  const metrics = [
    {
      title: 'Atendimentos',
      hint: 'Atendimentos realizados no período',
      value: indicators.totalAttendances.toLocaleString('pt-BR'),
      icon: attendancesIcon,
    },
    {
      title: 'PMR',
      hint: 'Prazo médio de recebimento',
      value: `${indicators.averageReceiptPeriod} dias`,
      icon: pmrIcon,
    },
    {
      title: 'Ticket médio',
      hint: 'Ticket médio de receita',
      value: <CurrencyLabel>{indicators.averageRevenueTicket}</CurrencyLabel>,
      icon: ticketIcon,
    },
  ]

  return (
    <section className={transfersCss.metricsGrid} aria-label="Indicadores">
      {metrics.map((metric) => (
        <article key={metric.title} className={`card ${transfersCss.metric}`}>
          <span className={transfersCss.metricIcon}>
            <img src={metric.icon} alt="" />
          </span>
          <div>
            <h3 className={transfersCss.metricTitle}>{metric.title}</h3>
            <p className={transfersCss.metricValue}>{metric.value}</p>
            <p className={transfersCss.metricHint}>{metric.hint}</p>
          </div>
        </article>
      ))}
    </section>
  )
}

export default TransferMetrics
